import React from 'react';

const CopilotPrinterLogo = ({ size = 32, className = '' }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    aria-hidden="true"
  >
    <defs>
      <linearGradient id="bgGrad" x1="0" y1="0" x2="32" y2="32" gradientUnits="userSpaceOnUse">
        <stop offset="0%" stopColor="#7B6FD0" />
        <stop offset="100%" stopColor="#4DB8B2" />
      </linearGradient>
      <linearGradient id="uvGrad" x1="8" y1="12" x2="24" y2="12" gradientUnits="userSpaceOnUse">
        <stop offset="0%" stopColor="#00FFFF" />
        <stop offset="33%" stopColor="#FF00FF" />
        <stop offset="66%" stopColor="#FFFF00" />
        <stop offset="100%" stopColor="#FF8A00" />
      </linearGradient>
    </defs>
    {/* Background */}
    <rect width="32" height="32" rx="7" fill="url(#bgGrad)" />
    {/* Printer chassis */}
    <rect x="3" y="7" width="26" height="8" rx="1.5" fill="white" fillOpacity="0.9" />
    <rect x="5" y="15" width="22" height="12" fill="white" fillOpacity="0.9" />
    {/* UV print strip */}
    <rect x="8" y="10" width="16" height="4" rx="0.5" fill="url(#uvGrad)" />
    <rect x="10" y="11" width="12" height="0.5" fill="white" fillOpacity="0.6" />
    {/* Mechanical accents */}
    <rect x="4" y="9" width="1" height="4" fill="#FF8A00" />
    <circle cx="7" cy="27" r="1.5" fill="white" fillOpacity="0.9" />
    <circle cx="25" cy="27" r="1.5" fill="white" fillOpacity="0.9" />
    <path d="M10 24H22" stroke="white" strokeOpacity="0.6" strokeWidth="1" />
  </svg>
);

export default CopilotPrinterLogo;
